$ = require 'jquery'
ApiError = require 'app/scripts/network/api-error'
customError = require '@atlassian/trello-error-ext'
f = require 'effing'
assert = require 'app/scripts/lib/assert'
Promise = require 'bluebird'
_ = require 'underscore'

module.exports = class Batcher
  @BatchFailure = customError('Batcher::BatchFailure')

  _sent: false

  constructor: ->
    @_requests = []

  request: (url) ->
    assert !@_sent, "Cannot add requests to a batcher after sending!"
    new Promise (resolve, reject) =>
      @_requests.push { url, resolve, reject }

  send: ->
    assert !@_sent, "Cannot send more than once!"
    @_sent = true

    urls = @_requests.map(f.get('url')).join(',')
    request = null

    new Promise (outerResolve, outerReject) =>
      request = $.ajax
        data: { urls }
        url: '/1/batch'
        success: (data, textStatus, jqxhr) =>
          for [response, { resolve, reject }] in _.zip(data, @_requests)
            if '200' of response
              resolve response['200']
            else
              reject ApiError.fromResponse(response.statusCode, response.message)
          # Because jqxhr thinks it's then-able, we can't
          # resolve to it directly.
          outerResolve({ jqxhr })
        error: ({ status, responseText }) =>
          error = ApiError.fromResponse(status, responseText)
          for { reject } in @_requests
            reject Batcher.BatchFailure('', { error })
          outerReject(error)
    .cancellable().catch Promise.CancellationError, (e) ->
      request.abort()
      throw e
